import React, { Component } from "react";
import { Col, Button } from "react-bootstrap";

import deleteIcon from "../../assets/icons/x.svg";
import left from "../../assets/icons/left.png";
import right from "../../assets/icons/right.png";

class MapCaputeredImg extends Component {
  previewList = null;
  constructor(props) {
    super(props);
    this.state = {};
  }

  //REMOVE CANVAS
  deleteCanvas = (id) => {
    this.previewList.removeChild(this.previewList.childNodes[id]);
    this.props.childDeleteImg(id);
  };

  //scroll through captures Images
  scrollRight = () => {
    document.getElementById("picArray" + this.props.pKeyId).scrollBy(100, 0);
  };

  scrollLeft = () => {
    document.getElementById("picArray" + this.props.pKeyId).scrollBy(-100, 0);
  };

  componentDidMount() {
    this.previewList = document.getElementById("picArray" + this.props.pKeyId);
    this.setState({});
  }

  render() {
    let sampleCount;
    this.previewList = document.getElementById("picArray" + this.props.pKeyId);
    
    this.props.imgUrl.length > 0
      ? (sampleCount = this.props.imgUrl.length)
      : (sampleCount = "Add");
    if (this.previewList !== null) this.previewList.textContent = "";
    return (
      <div>
        <div
          style={{
            color: "#C2C0BD",
            marginLeft: "30px",
            marginTop: "16px",
            fontSize: "12px",
          }}
        >
          <Col xs={12}>{sampleCount} samples</Col>
        </div>
        <div style={{ marginTop: "5px", height: "70px" }}>
          <Col xs={1}>
            <div style={{ marginTop: "25px" }}>
              <Button
                style={{
                  padding: "0px",
                  border: "0px",
                  backgroundColor: "#2E3A53",
                  outline: "none",
                }}
                onClick={this.scrollLeft}
              >
                <img src={left} />
              </Button>
            </div>
          </Col>
          <Col xs={10}>
            <ul
              id={"picArray" + this.props.pKeyId}
              style={{
                marginTop: "12.5px",
                whiteSpace: "nowrap",
                overflowX: "hidden",
                overflowY: "hidden",
                scrollBehavior: "smooth",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {(this.props.imgUrl || []).map((canvas, index) => {
                let listItem = document.createElement("li");
                listItem.style.position = "relative";

                let closeImg = new Image();
                closeImg.src = deleteIcon;
                closeImg.onclick = this.deleteCanvas.bind(this, index);
                closeImg.style.position = "absolute";
                closeImg.style.marginLeft = "60%";
                listItem.appendChild(closeImg);

                listItem.appendChild(canvas);

                this.previewList.appendChild(listItem);
              })}
            </ul>
          </Col>
          <Col
            xs={1}
            style={{
              marginTop: "25px",
              padding: "0px",
            }}
          >
            <Button
              style={{
                margin: "0px",
                padding: "0px",
                border: "0px",
                backgroundColor: "#2E3A53",
                marginLeft: "-5px",
                outline: "none",
              }}
              onClick={this.scrollRight}
            >
              <img src={right} />
            </Button>
          </Col>
        </div>
      </div>
    );
  }
}

export default MapCaputeredImg;
